import {Generic3DModel} from "../models/generic-3D-model";
import {Constructor} from "../util/constructor-wrapper";
import {applyMixins} from "../util/apply-mixin";

/**
 * Decorator to apply features (mixin) to a class that is based on Generic3DModel
 * @param features
 * @constructor
 * @example
 * ```typescript
 *  @Features(Movable, Rotatable)
 *  class Foo extends Generic3DModel<Mesh>{
 *   ...implementation
 *  }
 *  ```
 */
export function Features(...features: Array<( ...args: any[] ) => any >){

    return function<T extends Constructor<Generic3DModel<any>>>(target: T){
        return applyMixins<any>(target, ...features);
    }

}